import { Injectable } from '@angular/core';
import { RegistrationService } from './registration.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class HotelNightsService {

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService,
    private registrationService: RegistrationService
  ) {}

  getHotelList() {

    var cleanedData = this.registrationService.cleanse(this.registrationService.getEnrollment({}));
    //  cleaned data
    const promise = new Promise((resolve, reject) => {
      this.http
        .post(this.environmentService.getEnvironmentUrl('service/hotelnights')
          , cleanedData)
        .subscribe((data: any) => {
          resolve(data);
        });
    });
    return promise;
  }
}
